import { render } from "./OwnerApprovalsPanel.vue?vue&type=template&id=3a93ce53&scoped=true"
import script from "./OwnerApprovalsPanel.vue?vue&type=script&lang=js"
export * from "./OwnerApprovalsPanel.vue?vue&type=script&lang=js"

import "./OwnerApprovalsPanel.vue?vue&type=style&index=0&id=3a93ce53&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a93ce53"]])

export default __exports__